import React from "react";
import SelectorGrid from "../SelectorGrid/SelectorGrid";
import SelectorAccordion from "../SelectorAccordion/SelectorAccordion";

const SidebarContent = props => {
  const {
    currentSubStepConfiguration,
    currentSubStepInfo,
    onAtomSelect,
    currentSubStepSelectedAtom,
    getIconImage,
    checkEnabledLevel
  } = props;

  const templateType = currentSubStepInfo ? currentSubStepInfo.template : "";
  const renderContent = () => {
    if (templateType === "grid") {
      return (
        <SelectorGrid
          checkEnabledLevel={(alias, type) => checkEnabledLevel(alias, type)}
          getIconImage={(alias) => getIconImage(alias)}
          currentSubStepSelectedAtom={currentSubStepSelectedAtom}
          onAtomSelect={(atom, type, link) => onAtomSelect(atom, type, link)}
          atoms={currentSubStepConfiguration}
          config={currentSubStepInfo}
        />
      );
    } else {
      return (
        <SelectorAccordion
          checkEnabledLevel={(alias, type) => checkEnabledLevel(alias, type)}
          getIconImage={(alias) => getIconImage(alias)}
          currentSubStepSelectedAtom={currentSubStepSelectedAtom}
          onAtomSelect={(atom, type, link) => onAtomSelect(atom, type, link)}
          atoms={currentSubStepConfiguration}
          config={currentSubStepInfo}
        />
      )
    }
  };

  return <div className="sidebar-content-in">{renderContent()}</div>;
};

export default SidebarContent;
